import { Box, Button, Typography } from "@mui/material";

interface WearableMetricDayDetailProps {
  color: string;
  displayValue: string;
  unit: string;
  dateLabel: string;
  onRestorePeriod?: () => void;
}

export function WearableMetricDayDetail({
  color,
  displayValue,
  unit,
  dateLabel,
  onRestorePeriod,
}: WearableMetricDayDetailProps) {
  const valueLine = unit ? `${displayValue} ${unit}` : displayValue;

  return (
    <Box
      sx={{
        minHeight: 180,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        borderRadius: 2,
        bgcolor: "background.paper",
        border: "1px dashed",
        borderColor: "divider",
        px: 2,
        py: 3,
      }}
    >
      <Typography variant="h5" fontWeight={700} sx={{ color, textAlign: "center" }}>
        {valueLine}
      </Typography>
      <Typography variant="body2" color="text.secondary" textAlign="center">
        Dados do dia {dateLabel}
      </Typography>
      {onRestorePeriod ? (
        <Button
          size="small"
          variant="text"
          onClick={onRestorePeriod}
          sx={{ mt: 0.5, fontWeight: 600 }}
        >
          Voltar ao período anterior
        </Button>
      ) : null}
    </Box>
  );
}
